export class SdkError extends Error {
    public override name = "SdkError";

    constructor(
        message: string,
        public status: number,
        public data?: unknown,
    ) {
        super(message);
    }
}

export class NotFoundError extends SdkError {
    public override name = "NotFoundError";

    constructor(message = "not found", data?: unknown) {
        super(message, 404, data);
    }
}

export class InvalidRequestError extends SdkError {
    public override name = "InvalidRequestError";

    constructor(message = "invalid request", data?: unknown) {
        super(message, 400, data);
    }
}

export class UnauthorizedError extends SdkError {
    public override name = "UnauthorizedError";

    constructor(message = "unauthorized", data?: unknown) {
        super(message, 401, data);
    }
}

export class ForbiddenError extends SdkError {
    public override name = "ForbiddenError";

    constructor(message = "forbidden", data?: unknown) {
        super(message, 403, data);
    }
}

export class ConflictError extends SdkError {
    public override name = "ConflictError";

    constructor(message = "conflict", data?: unknown) {
        super(message, 409, data);
    }
}

export class InternalServerError extends SdkError {
    public override name = "InternalServerError";

    constructor(message = "internal server error", data?: unknown) {
        super(message, 500, data);
    }
}
